import React, { useState, useRef, useEffect } from "react";
import { LayoutHome } from "../LayoutHome";
import { Button, Card, Table, Space, notification, Input } from "antd";
import {
  NumberInput,
  Text,
  Checkbox,
  Tag,
  Image,
  ButtonGroup,
  Panel,
  Modal,
  Image as Img,
} from "rsuite";
import { FaPencilAlt, FaPlus, FaSave, FaSign } from "react-icons/fa";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import SignatureCanvas from "react-signature-canvas";
import {
  Check,
  DoorClosed,
  Eraser,
  LucideAArrowDown,
  PlusCircleIcon,
  RefreshCcw,
  Save,
} from "lucide-react";
import { getListEnfermeras, saveEnfermera } from "../Services/CatalogosServices";

export const Enfermeria = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [idEnf, setIdEnf] = useState(0);
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [msjErrMail, setErrMail] = useState("");
  const [esJefe, setEsJefe] = useState(0);
  const [activo, setActivo] = useState(1);
  const [foto, setFoto] = useState("");
  const [editarFoto, setEditarFoto] = useState(false);
  const [file, setFile] = useState([]);
  const [data, setData] = useState([]);
  const [openModalFirma, setOpenModalFirma] = useState(false);
  const [dataFirma, setDataFirma] = useState("");
  const [imageFirmaEnf, setImageFirmaEnf] = useState("/Images/SinFirma.jpg");
  const [dataFirmaEnf, setDataFirmaEnf] = useState("");

  const [api, contextHolder] = notification.useNotification();

  const initialized = useRef(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleCloseModalFirma = () => {
    setOpenModalFirma(false);
  };

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const signCanvas = useRef({});

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Nombre(s)",
      dataIndex: "nombre",
      width: "20%",
      key: "nombre",
      sorter: (a, b) => a.nombre.length - b.nombre.length,
      ...getColumnSearchProps("nombre"),
    },
    {
      title: "Apellidos",
      dataIndex: "apellidos",
      width: "20%",
      key: "apellidos",
      sorter: (a, b) => a.apellidos.length - b.apellidos.length,
      ...getColumnSearchProps("apellidos"),
    },
    {
      title: "Foto",
      dataIndex: "foto",
      width: "10%",
      key: "foto",
      align: "center",
      render: (text, record) => (
        <Image
          circle
          src={`Unidades/${idNegocio}/Enfermeria/${record.idEnf}/${record.foto}`}
          alt="Foto"
          width={60}
          height={60}
        />
      ),
    },
    {
      title: "Firma",
      dataIndex: "firma",
      width: "10%",
      key: "firma",
      align: "center",
      render: (text, record) => (
        <Image
          circle
          src={
            record.firma !== "SinFirma.jpg"
              ? `Unidades/${idNegocio}/Enfermeria/${record.idEnf}/${record.firma}`
              : `Images/${record.firma}`
          }
          alt="Firma"
          width={60}
          height={60}
        />
      ),
    },
    {
      title: "Es Jefe",
      dataIndex: "esJefe",
      width: "5%",
      key: "esJefe",
      align: "center",
      render: (text) =>
        text === 1 ? <Tag color="blue">Si</Tag> : <Tag color="#000">No</Tag>,
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      width: "10%",
      key: "telefono",
      align: "center",
    },
    {
      title: "Correo",
      dataIndex: "correo",
      width: "30%",
      key: "correo",
    },
    {
      title: "Estatus",
      dataIndex: "activo",
      width: "5%",
      key: "activo",
      align: "center",
      render: (text) =>
        text === 1 ? (
          <Tag color="green">Activo</Tag>
        ) : (
          <Tag color="red">Inactivo</Tag>
        ),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "5%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          icon={<EditOutlined />}
          color="primary"
          variant="outlined"
          onClick={() =>
            edit({
              idEnf: record.idEnf,
              nombre: record.nombre,
              apellidos: record.apellidos,
              telefono: record.telefono,
              correo: record.correo,
              foto: record.foto,
              firma: record.firma,
              esJefe: record.esJefe,
              activo: record.activo,
            })
          }
        ></Button>
      ),
    },
  ];

  const edit = (props) => {
    setEditarFoto(true);
    setIdEnf(props.idEnf);
    setNombre(props.nombre);
    var _path = `Unidades/${idNegocio}/Enfermeria/${props.idEnf}/${props.firma}`;
    if(props.firma === 'SinFirma.jpg'){
      _path = `Images/${props.firma}`;
    }
    setImageFirmaEnf(_path);
    setApellidos(props.apellidos);
    setTelefono(props.telefono);
    setCorreo(props.correo);
    setFoto(props.foto);
    setEsJefe(props.esJefe);
    setActivo(props.activo);
  };

  const validateEmail = (email) => {
    setCorreo(email);
    if (!email) {
      setErrMail("");
      return;
    }
    // A common regex pattern for email format validation
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      setErrMail("*Formato incorrecto*");
    } else {
      setErrMail("");
    }
  };

  const handleFile = (e) => {
    setFile(e.target.files);
  };

  const checkEsJefe = (e) => {
    if (e.target.checked) {
      setEsJefe(1);
    } else {
      setEsJefe(0);
    }
  };

  const checkActivo = (e) => {
    if (e.target.checked) {
      setActivo(1);
    } else {
      setActivo(0);
    }
  };

  const loadListEnfermeria = async () => {
    await getListEnfermeras(idNegocio)
      .then((res) => {
        setData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const save = async () => {
    if (nombre.length === 0) {
      errorNotificaction("Nombre", "El nombre no puede estar vacio...");
      return;
    }
    if (apellidos.length === 0) {
      errorNotificaction(
        "Apellidos",
        "Los apellidos no pueden estar vacios...",
      );
      return;
    }
    if (msjErrMail !== "") {
      errorNotificaction("Correo", "El formato de correo es inválido...");
      return;
    }

    const formData = new FormData();
    formData.append("id", idNegocio);
    formData.append("idEnf", idEnf);
    formData.append("nombre", nombre);
    formData.append("apellidos", apellidos);
    formData.append("telefono", telefono);
    formData.append("correo", correo);
    formData.append("esJefe", esJefe);
    formData.append("foto", foto);
    formData.append("firma", imageFirmaEnf);
    formData.append("activo", activo);
    formData.append("file", file !== null ? file[0] : null);

    await saveEnfermera(formData).then(async (res) => {
      if (res > 0) {
        successNotification(
          "Registro",
          "Se ha registrado la información de forma correcta.",
        );
        setTimeout(() => {
          setIdEnf(0);
          window.location.reload();
        }, 1000);
        setIdEnf(0);
      } else {
        errorNotificaction("No se ha registrado la información...", "Error");
      }
    });
  };

  const clear = () => signCanvas.current.clear();

  const saveSignature = () => {
    if (signCanvas.current) {
      const data = signCanvas.current.toDataURL("image/png");
      setImageFirmaEnf(data);
      setDataFirmaEnf(data);
      setOpenModalFirma(false);
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadListEnfermeria();
    }
  }, []);

  return (
    <>
      <title>Enfermería - NefroSys</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Inicio
              </a>
            ),
          },
          { title: "Enfermería" },
        ]}
        selectedKey={"1.2"}
      >
        {contextHolder}
        <Card title="Datos del perfil - Ennfermería">
          <div className="row mb-2">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Nombre</Text>
              <Input
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Apellidos</Text>
              <Input
                value={apellidos}
                onChange={(e) => setApellidos(e.target.value)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Teléfono</Text>
              <NumberInput
                controls={false}
                value={telefono}
                maxLength={10}
                onChange={(e) => setTelefono(e)}
              />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Text>Correo</Text>
              <Input
                value={correo}
                onChange={(e) => validateEmail(e.target.value)}
              />
              <Text size={"xs"} color={"red"} style={{ paddingTop: "5px" }}>
                {msjErrMail}
              </Text>
            </div>
            <div className="text-center col-lg-2 col-md-2 col-sm-2">
              <Text>Es Jefe</Text>
              <Checkbox
                onClick={(e) => checkEsJefe(e)}
                checked={esJefe === 1 ? true : false}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-4">
              {!editarFoto ? (
                <>
                  <Text>Cargar foto...</Text>
                  <input type="file" onChange={(e) => handleFile(e)} />
                </>
              ) : (
                <>
                  <Text>Foto actúal</Text>
                  <Image
                    circle
                    src={`Unidades/${idNegocio}/Enfermeria/${idEnf}/${foto}`}
                    alt="Enfermer@"
                    width={80}
                    height={80}
                  />
                  &nbsp;{" "}
                  <Button
                    variant="link"
                    color="primary"
                    onClick={() => setEditarFoto(false)}
                  >
                    <FaPencilAlt></FaPencilAlt>
                  </Button>
                </>
              )}
            </div>
            <div className="text-center col-lg-2 col-md-2 col-sm-2">
              <Text>Activo</Text>
              <Checkbox
                onClick={(e) => checkActivo(e)}
                checked={activo === 1 ? true : false}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text>Firma</Text>
              <Img
                rounded
                src={imageFirmaEnf}
                alt="Firma"
                style={{ border: "solid 0.1em", borderColor: "#D1D1D1" }}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <Button
                type="primary"
                icon={<FaSign></FaSign>}
                onClick={() => setOpenModalFirma(true)}
              >
                Cargar firma...
              </Button>
            </div>
            <div className="text-end col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <ButtonGroup divided vertical>
                <Button
                  icon={<FaPlus></FaPlus>}
                  onClick={() => window.location.reload()}
                  color="primary"
                  variant="outlined"
                  style={{ width: "110px" }}
                >
                  Nuevo
                </Button>
                &nbsp;
                <Button
                  icon={<FaSave></FaSave>}
                  onClick={save}
                  type="primary"
                  style={{ width: "110px" }}
                >
                  Guardar
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </Card>
        <br></br>
        <Card title="Lista de Personal de Enfermería">
          <div className="row">
            <div className="col">
              <Table
                bordered
                size="small"
                rowKey={(record) => record.idEnf}
                columns={columns}
                dataSource={data}
                pagination={{ pageSize: 5 }}
              />
            </div>
          </div>
        </Card>
      </LayoutHome>

      {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> MODAL FIRMAS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
      <Modal size={"md"} open={openModalFirma} onClose={handleCloseModalFirma}>
        <Modal.Header>
          <Modal.Title>Firma del Enfermero(a)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered>
            <SignatureCanvas
              ref={signCanvas}
              canvasProps={{
                style: { width: "100%", minHeight: "376px" },
              }}
            />
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            icon={<Eraser></Eraser>}
            color="default"
            variant="solid"
            onClick={clear}
          >
            Borrar
          </Button>
          <Button
            icon={<Save size={16}></Save>}
            type="primary"
            onClick={saveSignature}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
